import { Component } from 'react';
import { useLocation } from 'react-router-dom';

class Boundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) {
      // A failed toast must not replace the open editor.
      if (this.props.quiet) return null;
      return <div className="p-8 space-y-3" role="alert">
        <p>This page could not be opened. Reload to get the current app version.</p>
        <button type="button" className="rounded border px-3 py-2" onClick={() => window.location.reload()}>Reload app</button>
      </div>;
    }
    return this.props.children;
  }
}

export function QuietErrorBoundary({ children }) {
  const location = useLocation();
  return <Boundary key={location.pathname} quiet>{children}</Boundary>;
}

export default function PageLoadBoundary({ children }) {
  const location = useLocation();
  // A failed page chunk should not prevent opening another route.
  return <Boundary key={location.pathname}>{children}</Boundary>;
}
